import React from "react";
import {
  Li,
  Ul,
  P,
  Ol,
  Accordion,
  AccordionGroup,
  Margin,
} from "@ovotech/element";

export const AndersenFAQ = () => {
  return (
    <>
      <Margin top={10} />
      <AccordionGroup>
        <Accordion title="What’s included in a standard installation?">
          <P>
            Our standard charger installations take around 3 hours to complete
            and include:
          </P>
          <Ul>
            <Li>
              Our expert engineers fitting the EV charger to a brick/rendered
              wall.
            </Li>

            <Li>
              Up to 10 meters of 6mm power cable – this is neatly clipped to the
              wall between the electricity supply meter and the charger.
            </Li>

            <Li>
              Setting up the charger and pairing with your smartphone via WiFi
              or 4G – with full support from our engineer.
            </Li>

            <Li>A full demonstration of how your new charger works.</Li>
          </Ul>
          <P>For a standard installation to go ahead:</P>
          <Ol>
            <Li>
              The existing electrical connections and protections within your
              home must be in good condition.
            </Li>

            <Li>
              All required main protective bonding at the property must be
              installed and adequately sized before the installation of the
              Charge point.
            </Li>

            <Li>
              No groundworks/civil works, electrical remedial works or any other
              trades need to be carried out.
            </Li>
          </Ol>

          <P>
            If any of these requirements aren’t met, our surveyors will let you
            know. But please note that any work that needs to be done would need
            to be arranged by the customer. Our engineers can carry out Earth
            bonding upgrades for an additional cost. Main isolation switches can
            also be fitted for OVO customers on the day of install for an
            additional cost.
          </P>
        </Accordion>
        <Accordion title="Can I change my mind later?">
          <P>
            Yes you can. You can change your mind about the customisation until
            you make a payment. After this point, it’s still possible, but would
            take a little longer – as we’d have to re-create your profile,
            refund your payment, and send you a new quote.
          </P>
        </Accordion>
      </AccordionGroup>
    </>
  );
};
